/* LS store hours: open/closed status in each store's own time zone, refreshed every minute. */
(function () {
  if (window.LSHours) return;

  var E = 'America/New_York', C = 'America/Chicago', M = 'America/Denver', P = 'America/Los_Angeles';
  var STATE_TZ = {
    CT: E, DE: E, DC: E, FL: E, GA: E, IN: E, KY: E, ME: E, MD: E, MA: E, MI: E, NH: E, NJ: E, NY: E,
    NC: E, OH: E, PA: E, RI: E, SC: E, TN: E, VT: E, VA: E, WV: E,
    AL: C, AR: C, IL: C, IA: C, KS: C, LA: C, MN: C, MS: C, MO: C, NE: C, ND: C, OK: C, SD: C, TX: C, WI: C,
    AZ: 'America/Phoenix', CO: M, ID: M, MT: M, NM: M, UT: M, WY: M,
    CA: P, NV: P, OR: P, WA: P, AK: 'America/Anchorage', HI: 'Pacific/Honolulu'
  };
  var DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];

  // Store's time zone from its state, with longitude used for states split between two zones.
  function tzFor(state, lon) {
    var s = String(state || '').trim().toUpperCase();
    var x = Number(lon);
    if (isFinite(x) && x !== 0) {
      if (s === 'IN' && x < -86.95) return C;
      if (s === 'KY' && x < -85.95) return C;
      if (s === 'TN' && x < -85.45) return C;
      if (s === 'FL' && x < -85.0) return C;
      if (s === 'MI' && x < -87.6) return C;
      if (s === 'TX' && x < -104.9) return M;
      if ((s === 'NE' || s === 'KS' || s === 'ND' || s === 'SD') && x < -101.5) return M;
    }
    return STATE_TZ[s] || null;
  }

  // Current weekday and minutes since midnight in the given time zone (falls back to the device clock).
  function nowIn(tz) {
    var d = new Date();
    if (tz && window.Intl && Intl.DateTimeFormat) {
      try {
        var parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, weekday: 'long', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(d);
        var o = {};
        parts.forEach(function (p) { o[p.type] = p.value; });
        return { day: String(o.weekday).toLowerCase(), min: (Number(o.hour) % 24) * 60 + Number(o.minute) };
      } catch (e) {}
    }
    return { day: DAYS[d.getDay()], min: d.getHours() * 60 + d.getMinutes() };
  }

  function toMin(s) {
    var m = String(s).trim().toLowerCase().match(/^(\d{1,2})(?::(\d{2}))?\s*(am|pm)?$/);
    if (!m) return null;
    var h = Number(m[1]) % 12;
    if (m[3] === 'pm') h += 12;
    return h * 60 + Number(m[2] || 0);
  }

  // hours: "Monday: 10:00am-8:00pm" lines (string with newlines, or an array of lines).
  function status(hours, tz) {
    var n = nowIn(tz);
    var lines = Array.isArray(hours) ? hours : String(hours || '').split('\n');
    var line = null;
    for (var i = 0; i < lines.length; i++) {
      if (String(lines[i]).trim().toLowerCase().indexOf(n.day) === 0) { line = String(lines[i]); break; }
    }
    if (!line) return null;
    var rest = line.slice(line.indexOf(':') + 1).trim();
    if (/closed/i.test(rest)) return { open: false, day: n.day, text: 'Closed today' };
    var t = rest.split(/\s*[-\u2013]\s*/);
    if (t.length !== 2) return null;
    var o = toMin(t[0]);
    var c = toMin(t[1]);
    if (o === null || c === null) return null;
    if (n.min >= o && n.min < c) return { open: true, day: n.day, text: 'Open now \u00b7 until ' + t[1].trim() };
    if (n.min < o) return { open: false, day: n.day, text: 'Closed \u00b7 opens ' + t[0].trim() };
    return { open: false, day: n.day, text: 'Closed now' };
  }

  // Store finder cards: <p class="ey-sf__hours" data-ls-h data-ls-st data-ls-lon>
  function refreshFinder() {
    document.querySelectorAll('.ey-sf__hours[data-ls-h]').forEach(function (p) {
      var tz = tzFor(p.getAttribute('data-ls-st'), p.getAttribute('data-ls-lon'));
      var day = nowIn(tz).day;
      var s = status(p.getAttribute('data-ls-h'), tz);
      var on = false;
      Array.prototype.forEach.call(p.children, function (k) {
        k.classList.remove('is-today', 'is-open', 'is-shut');
        if (k.classList.contains('ey-sf__hday')) on = k.textContent.trim().toLowerCase() === day;
        else if (k.classList.contains('ey-sf__hrow-raw')) on = false;
        if (on) k.classList.add('is-today', s && s.open ? 'is-open' : 'is-shut');
      });
      var box = p.closest('.ey-sf__info--hours') || p.parentElement;
      var badge = box && box.querySelector('.ey-sf__status');
      if (badge && s) {
        badge.textContent = s.text;
        badge.classList.toggle('is-closed', !s.open);
      }
    });
  }

  // Store details page (.ls-location)
  function refreshStorePage() {
    var root = document.querySelector('.ls-location');
    if (!root) return;
    var addr = root.querySelector('.ls-address');
    var st = addr && addr.textContent.match(/,\s*([A-Z]{2})\s+\d{5}/);
    var map = root.querySelector('[data-lon]');
    var tz = tzFor(st && st[1], map && map.getAttribute('data-lon'));
    var day = nowIn(tz).day;
    var rows = Array.prototype.slice.call(root.querySelectorAll('.ls-hours tr'));
    var lines = rows.map(function (tr) {
      var th = tr.querySelector('th');
      var td = tr.querySelector('td');
      return th && td ? th.childNodes[0].textContent.trim() + ': ' + td.textContent.trim() : '';
    });
    var s = status(lines, tz);
    rows.forEach(function (tr) {
      var th = tr.querySelector('th');
      if (!th) return;
      var isToday = th.childNodes[0].textContent.trim().toLowerCase() === day;
      var tag = th.querySelector('.ls-today-tag');
      tr.classList.toggle('is-today', isToday);
      tr.classList.toggle('is-open', isToday && !!(s && s.open));
      if (isToday && !tag) {
        tag = document.createElement('span');
        tag.className = 'ls-today-tag';
        tag.textContent = 'Today';
        th.appendChild(tag);
      } else if (!isToday && tag) {
        tag.remove();
      }
    });
    if (s) {
      root.querySelectorAll('.ls-status').forEach(function (b) {
        b.textContent = s.text;
        b.classList.toggle('is-closed', !s.open);
      });
    }
  }

  function refresh() {
    try { refreshFinder(); } catch (e) {}
    try { refreshStorePage(); } catch (e) {}
  }

  window.LSHours = { tzFor: tzFor, nowIn: nowIn, status: status, refresh: refresh };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
  setInterval(refresh, 60000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
})();
